// extracted by mini-css-extract-plugin
export default {"waiting":"waiting_waiting__fFzUf"};